

export const MAIN_MENU_CLASS_STATE_OPEN = 'menu-open';
export const MAIN_MENU_CLASS_STATE_CLOSED = 'menu-closed';


//EXPERIENCE TITLE POSITION
export const TITLE_POSITION_EXPERIENCE_AND_SCREEN = "experience_and_screen";
export const TITLE_POSITION_SCREEN_ONLY = "screen_only";
export const TITLE_POSITION_EXPERIENCE_ONLY = "experience_only";

//EXPERIENCE HOME POSITION
export const HOME_POSITION_HIDDEN = "hidden";
export const HOME_POSITION_LEFT = "left";
export const HOME_POSITION_RIGHT = "right";
export const HOME_POSITION_IN_MENU = "in_menu";

//EXPERIENCE EXIT STYLE
export const EXIT_STYLE_HIDDEN = "hidden";
export const EXIT_STYLE_SAVE_AND_EXIT = "save_and_exit";
export const EXIT_STYLE_EXIT = "exit";
export const EXIT_STYLE_CLOSE = "close";


//EXPERIENCE ACHIEVEMENTS STYLE
export const ACHIEVEMENTS_STYLE_HIDDEN = "hidden";
export const ACHIEVEMENTS_STYLE_ROUND = "round";
export const ACHIEVEMENTS_STYLE_SHIELD = "shield";


export const HEADER_TEXT_ALIGNMENT_CENTER  = "center";
export const HEADER_TEXT_ALIGNMENT_LEFT  = "left";




/** WEBPACK FOOTER **
 ** ./src/constants/navigationConstants.js
 **/